import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IS1InputSelectItem } from '@app/s1';
import { CheckType } from '@app/shared/models/models';
import { ISearchCodiciModelloParams, ModelloService } from '@app/shared/services/modello.service';

@Component({
    selector: 'mdm-input-codici-modello-select',
    templateUrl: './input-codici-modello-select.component.html',
    styleUrl: './input-codici-modello-select.component.scss',
    standalone: false
})
export class InputCodiciModelloSelectComponent implements AfterViewInit {

  @Input() options: Array<IS1InputSelectItem>;
  @Input() label: string;
  @Input() control: UntypedFormControl;
  @Input() bindAllObject: boolean = true;
  @Input() readonly: boolean = false;
  @Input() type: CheckType;
  @Output() onSelectClear = new EventEmitter();
  @Output() onSelectChange = new EventEmitter();

  constructor(private modelloService: ModelloService) { }
  
  ngAfterViewInit(): void {
    this.search();
  }

  ngOnInit(): void {}
  
  cleared() {
    this.onSelectClear.emit();
  }

  changed(event) {
    this.onSelectChange.emit(event);
  }

  search(text?: string) {

    if (text?.length < 3 || this.type == null) {
      this.options = [];
      return;
    }

    const params: ISearchCodiciModelloParams = {
      codiceModello: text,
      paging: true,
      page: 1,
      rows: 30
    }

    this.modelloService.getCodiciModello(params, this.type).subscribe(options => {

      this.options = options.map(option => {

        return {
          code: option.code,
          label: option.label
        } as IS1InputSelectItem

      })

    })

  }

}
